/* eslint-disable unicode-bom */
import { api } from "./api";

export async function getGlobalLogo(): Promise<any> {
  try {
    const response = await api.get("/database/global_logo__c", {
      headers: {
        "X-Use-Bearer-Auth": "true",
      },
    });
    console.log("Resposta completa da API (getGlobalLogo):", response);
    console.log("response.data:", response.data);

    // Se response.data for um array, pegar o primeiro item
    if (Array.isArray(response.data)) {
      return response.data[0];
    }

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar logo global:", error);
    throw error;
  }
}

export async function updateGlobalLogo(logoData: {
  _id: string;
  logoUrl: string;
  created?: number;
  updated?: { $date: number };
}): Promise<any> {
  try {
    const response = await api.put("/database/global_logo__c", logoData);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar logo global:", error);
    throw error;
  }
}
